import React from 'react';

import PropTypes from 'prop-types';

import { FormattedMessage } from '~/techstyle-shared/react-intl';

import { EmbroideryLine, DetailText, CustomizationText } from './styles';

const TextCustomizations = ({ textCustomizations, embroideryConfigs }) => {
  if (!textCustomizations.line1 && !textCustomizations.line2) {
    return null;
  }

  const { color, font, line1, line2, textLocation } = textCustomizations;

  const locationRb = embroideryConfigs.find((config) => {
    return typeof textLocation === 'number'
      ? config.customizationLocationTemplateId === textLocation
      : config.resourceBundle.defaultMessage === textLocation;
  })?.resourceBundle;

  return (
    <>
      <EmbroideryLine>
        <FormattedMessage
          id="site_pdp.embroidery_custom_text_line_item"
          defaultMessage="Custom Text"
        />
        {': '}
        <DetailText>
          <DetailText>
            {locationRb && <FormattedMessage {...locationRb} />}
            {', '}
          </DetailText>
          <DetailText>
            <FormattedMessage
              id="site_pdp.embroidery_font"
              defaultMessage="{font} Font"
              values={{ font }}
            />
          </DetailText>
          {', '}
          <FormattedMessage
            id="site_pdp.embroidery_thread"
            defaultMessage="{color} Color"
            values={{ color }}
          />
        </DetailText>
      </EmbroideryLine>{' '}
      {line1 && (
        <>
          <EmbroideryLine>
            <FormattedMessage
              id="site_pdp.embroidery_line"
              defaultMessage="Line {number}"
              values={{ number: '1' }}
            />
            {': '}
            <CustomizationText>{line1}</CustomizationText>
          </EmbroideryLine>{' '}
        </>
      )}
      {line2 && (
        <>
          <EmbroideryLine>
            <FormattedMessage
              id="site_pdp.embroidery_line"
              defaultMessage="Line {number}"
              values={{ number: '2' }}
            />
            {': '}
            <CustomizationText>{line2}</CustomizationText>
          </EmbroideryLine>
        </>
      )}
    </>
  );
};

TextCustomizations.propTypes = {
  embroideryConfigs: PropTypes.array,
  textCustomizations: PropTypes.shape({
    textLocation: PropTypes.oneOf([1, 2]),
    line1: PropTypes.string,
    line2: PropTypes.string,
    color: PropTypes.string,
    font: PropTypes.string,
  }),
};

export default TextCustomizations;
